/// Git : https://github.com/caroso1222/notyf

import { Notyf } from 'notyf';
import i18n from '@/i18n'

export default {
    install(app) {
        const notyf = new Notyf({
            position: { x: 'center', y: 'top' },
            types: [
                {
                    type: 'warning',
                    background: 'orange',
                    icon: false,
                    dismissible: true
                },
                {
                    type: 'info',
                    background: 'blue',
                    icon: false,
                    dismissible: true
                }
            ]
        });

        app.config.globalProperties.notyf = {
            success(message, duration = 3000) {
                notyf.open({
                    type: 'success',
                    message,
                    duration,
                    dismissible: true
                });
            },
            warning(message, duration = 3000) {
                notyf.open({
                    type: 'warning',
                    icon: false,
                    message,
                    duration,
                    dismissible: true
                });
            },
            error(message, duration = 3000) {
                notyf.open({
                    type: 'error',
                    message,
                    duration,
                    dismissible: true
                });
            },
            open(options) {
                notyf.open(options);
            },
            apiResult(result, duration = 3000) {

                const key = `apiResultStatusCodes.${result.StatusCode}`

                let message = i18n.global.t(key)

                if (message === key) {
                    message = result.Message
                }

                notyf.open({
                    type: result.IsSuccess ? 'success' : 'error',
                    message: message,
                    duration: duration,
                    dismissible: true
                });
            }

        };
    },
};
